export default "__VITE_ASSET__B6eUedfT__"